<div #dialogContainer siqGrid fx-direction="column" fx-layout-align="space-between stretch" class="p-12 pb-24"
  role="dialog"
  aria-labelledby="popup-title"
  aria-describedby="popup-text"
  tabindex="0">

  <div #closeButton tabindex="0" aria-label="close" role="button" siqGrid fx-layout-align="end center" class="cursor-pointer" (click)="onCloseClick()" (keyup.enter)="onCloseClick()">
    <span class="close-gray-icon"></span>
  </div>

  <div siqGrid fx-direction="row" fx-layout-align="center center">
    <div siqGrid fx-layout-align="center center" [class]="iconClasses">
      <span [class]="data.icon"></span>
    </div>
  </div>

  <div id="popup-title" tabindex="0" class="siq-text-700 fs-20 primary text-center mt-24" [innerHTML]="data.title" aria-level="1" role="heading"></div>
  <div siqGrid fx-direction="row" fx-layout-align="center center">
    <div id="popup-text" tabindex="0" class="siq-text-400 fs-14 primary-300 text-center mt-12 w-100-p" [innerHTML]="data.text" aria-level="2" role="heading"></div>
  </div>

  <div siqGrid fx-direction="row" fx-layout-align="center center" class="w-100-p mt-24">

      <ng-container *ngIf="!data.hideLeftButton">
        <div class="w-50-p text-center">
          <app-siq-button
            tabindex="1"
            [ariaLabel]="data.leftBtnTxt" 
            [text]="data.leftBtnTxt" 
            btnType="tertiary-btn text-color-secondary mr-12" 
            width="100%"
            [iconPosition]="data.leftBtnIcon?.position ?? iconPositionFallback"
            [icon]="data.leftBtnIcon?.icon ?? ''"
            (buttonClicked)="onLeftActionClick()"
            (keyup.enter)="onLeftActionClick()" />
        </div>
      </ng-container>

      <ng-container *ngIf="!data.hideRightButton">
        <div [class]="btnClasses">
          <app-siq-button
            tabindex="2"
            [ariaLabel]="data.rightBtnTxt"
            [text]="data.rightBtnTxt" 
            btnType="primary-btn" 
            width="100%"
            [iconPosition]="data.rightBtnIcon?.position ?? iconPositionFallback"
            [icon]="data.rightBtnIcon?.icon ?? ''"
            (buttonClicked)="onRightActionClick()"
            (keyup.enter)="onRightActionClick()"
            (keydown.tab)="moveFocusToCloseButton($event)" />
        </div>
      </ng-container>

    </div>
</div>